/* eslint-disable no-eval */
import { Fragment, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  FormGroup,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import Error from "../../components/messagesModal/error";
import Success from "../../components/messagesModal/success";
import RetryQuery from "../../components/messagesModal/retryQuery";
import ErrorZeroBalance from "../../components/messagesModal/errorZeroBalance";
import BaseService from "../../services/baseService";
import Validation from "../../utils/validation";
import { formatCurrency } from "../../utils/converts";
import { actions as actionsSite } from "../../redux/actions/site";

import "./consultas.scss";
import { ErrorMessage, Field, Formik } from "formik";
import Termos from "./Termos";
import { dataPorExtenso } from "../../utils/utils";
import { validaCnpj, validaCpf } from "../../utils/helpers";
import { cnpjMask, cpfMask } from "../../utils/mask";

const baseService = new BaseService("consulta");

const Consultas = () => {
  new Validation(Yup);
  const profile = useSelector((state) => state.auth.profile);

  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({});
  const [validationSchema, setValidationSchema] = useState({});
  const [query, setQuery] = useState(null);
  const [price, setPrice] = useState(null);
  const [message, setMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [cpfInput,setCpfInput] = useState("");
  const [cnpjInput,setCnpjInput] = useState("");
  
  const [termosText, setTermosText] = useState("");

  const goOrderPayment = useCallback(() => {
    dispatch(actionsSite.closeModal());
    history.push("/financeiro/ordens-de-pagamento");
  },[dispatch, history]);

  const showMessageModal = useCallback(({ error, msg, icon=null, loadingCar=false }) => {
    const CompError = msg.includes('Sem saldo para realizar') ? ErrorZeroBalance : Error ;
    const configModal = {
      component: error ? <CompError msg={msg} goOrderPayment={goOrderPayment} /> : <Success msg={msg} icon={icon} loadingCar={loadingCar} />,
      title: error ? `Erro` : `Sucesso`,
    };
    dispatch(actionsSite.setModal(configModal));
  },[dispatch, goOrderPayment]);

  const getQueryCode = useCallback(() => {
    const code = location.pathname.split("/").pop();
    return code;
  },[location]);

  const getQuery = useCallback(async () => {
    const code = getQueryCode();
    const query = profile.permissionsQueries.find((q) => q.code === code);
    return query;
  },[profile, getQueryCode]);

  const getQueryPrice = useCallback(async (query) => {
    const _query = profile.clientPrice.queries.find(price => price.query === query._id);
    return _query.price;
  },[profile]);

  useEffect(() => {
    const run = async () => {
      setMessage(null);
      setLoading(true);
      const _query = await getQuery();

      if (_query) {
        const _price = await getQueryPrice(_query);
        setQuery(_query);
        setPrice(_price);

          setLoading(false);
      } else {
        showMessageModal({ error: true, msg: "Consulta não encontrada" });
        history.push("/dashboard");
      }
    };

    run();
  }, [location, showMessageModal, history, getQueryPrice, getQuery]);

  useEffect(() => {
    const run = async () => {
      const fields = {};
      const fieldsValidation = {};
      if (query) {
        for (let q of query.input) {
          fields[q.field] = "";
          fieldsValidation[q.field] = Yup.string();
          if (q.validation) {
            fieldsValidation[q.field] = fieldsValidation[q.field][q.validation](
              `Campo ${q.label} é inválido`
            );
          }
        }
        if(query.isTermsToAccept){
          fields["isTermsToAccept"] = false;
          fieldsValidation["isTermsToAccept"] = Yup
          .boolean()
          .oneOf([true], 'Você deve aceitar os termos');
        }
        setInitialValues(fields);

        const validationSchema = Yup.object().shape(fieldsValidation);
        setValidationSchema(validationSchema);
      }
    };
    run();
  }, [query]);

   useEffect(() => {
    const run = async () => {
      setTermosText(getTermosText())
    };
    run();
  }, [cpfInput,cnpjInput, query]);

  const getTermosText = () => {
    if(query){
      let str = query.textTermsBase;
      const input = cpfInput ?? cnpjInput;
      const inputIsCpf = validaCpf(input);
      const inputIsCnpj = validaCnpj(input);

      let clientToContract = profile.client.clientOwner;
      if(parseInt(profile.client.level) === 0){
        clientToContract = profile.client;
      }

      const document = clientToContract.document ?? "--";
      const documentIsCpf = validaCpf(document);
      const documentIsCnpj = validaCnpj(document);


      str = str.replace("{input}",inputIsCpf ? cpfMask(input) :  inputIsCnpj ? cnpjMask(input): input);
      str = str.replace("{document}",documentIsCpf ? cpfMask(document) : documentIsCnpj ? cnpjMask(document) : document);
      str = str.replace("{companyName}",clientToContract.companyName ?? "--");
      str = str.replace("{dataPorExtenso}",dataPorExtenso(clientToContract.endereco?.cidade ?? "--"));
      return str;
    }
    return "";
  }

  const getLabelField = (input) => {
    return query.input.find((e) => e.field === input)?.label;
  };

  const validatePrePost = (values) => {
    if (query.inputsRequired) {
      const inputsRequired = query.inputsRequired;
      const conditionsOr = inputsRequired.split("||").map((v) => v.trim());
      for (const cond of conditionsOr) {
        const validates = {};
        const inputs = cond.split("&&").map((v) => v.trim());
        for (const input of inputs) {
          validates[input] = values[input].length > 0;
        }
        const anyFalse = Object.values(validates).filter((e) => e === false);
        if (anyFalse.length === 0) {
          return true;
        }
      }
      return false;
    }
    
    return true;
  };
  
  const execute = async (values) => {
    try {
      const validate = validatePrePost(values);
      if (validate && !isSubmitting) {
        if(query.isTermsToAccept){
          values["terms"] = getTermosText();
        }
        
        setMessage(null);
        setIsSubmitting(true);
        const url = `${baseService.route}/${query.code}`;
        
        if (query.type === 'Veiculares') {
          showMessageModal({ error: false, msg: "Solicitando a consulta, por favor aguarde", loadingCar: true });
        } else {
          showMessageModal({ error: false, msg: "Solicitando a consulta, por favor aguarde", icon: 'far fa-clock' });
        }

        baseService
          ._postConsulta(url, values)
          .then((res) => {
            if (res.success === false && res.duplicatedQuery) {
              const configModal = {
                component: <RetryQuery logquery={res.logqueryOrigin} msg={res.msg} execute={execute} values={values}/>,
                title: 'Suspeita de consulta em duplicidade',
              };
              dispatch(actionsSite.setModal(configModal));
              setIsSubmitting(false);
              return;
            }

            showMessageModal({ error: !res.success, msg: res.msg });
            setIsSubmitting(false);
            if (res.success) {
              history.push("/historico/" + res.logQuery);
            }
          })
          .catch((error) => {
            if (error.response) {
              showMessageModal({ error: true, msg: error.response.data.msg });
              setIsSubmitting(false);
            }
          });
      } else {
        setMessageError();
      }
    } catch (e) {
      console.log(e.toString());
    }
  };

  const setMessageError = () => {

    const inputs = query.inputsRequired;
    let messageError = "<b>Preencha os campos:</b> <br> ";
    const replacers = inputs
      .split(" ")
      .filter((a) => a.length > 0)
      .map((a) => a.trim());
    for (let replacer of replacers) {
      if (replacer.match(/\|\|/gi)) {
        messageError += " ou";
      } else if (replacer.match(/&&/gi)) {
        messageError += " e";
      } else {
        messageError += ` ${getLabelField(replacer)}`;
      }
    }

    setMessage({ text: messageError, error: true });
  };



  return (
    <Card>
      <CardBody>
        {loading ? (
          <div className="text-center">
            <Spinner color="danger" />
          </div>
        ) : (
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <Row>
              <Col xs="12">
                <CardTitle>
                  <i className={`${query.icon} mr-1`}></i>
                  {query.isBlocked ?
                  <>
                    <del className="mr-2">
                      {query.type} - {query.name}
                    </del>
                    <span className="text-danger">
                      - EM MANUTENÇÃO
                    </span>
                  </>
                  :
                    query.type + ' - ' + query.name + (profile.client.showPrice ? ` | R$ ${formatCurrency(price)}` : '')
                  }
                </CardTitle>
                <div dangerouslySetInnerHTML={{ __html: query.description }} className="mb-3"/>
              </Col>
            </Row>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={async (values) => await execute(values)}
            >
              {({ errors, touched, submitForm, setFieldValue }) => (
                <>
                  <Row>
                    {query &&
                      query.input.map((input, index) => {
                        return (
                          <>
                          <Col sm={query.input.length <= 4 ? (12 / query.input.length) : 4} key={index}>
                            <FormGroup>
                              <Label>{input.label}</Label>
                              {(!input.typeField || input.typeField === 'text') &&
                                <Field
                                type="text"
                                name={input.field}
                                
                                placeholder={input.placeholder || ""}
                                className={"form-control" + (errors[input.field] && touched[input.field] ? " is-invalid" : "")}
                                onKeyDown={(e) => { if (e.key === "Enter") submitForm(); }}
                                onChange={(e)=>{
                                  if (e.target.name === "cpf") setCpfInput(e.target.value.trim())
                                  if (e.target.name === "cnpj") setCnpjInput(e.target.value.trim())
                                  e.preventDefault();
                                  setFieldValue(input.field,e.target.value.trim())
                                }}
                                onPaste={(e)=>{
                                  e.preventDefault();
                                  setFieldValue(input.field,e.clipboardData.getData('Text').trim())
                                }}
                                />
                              }
                              {(input.typeField && input.typeField === 'select') &&
                                <Field
                                as="select"
                                name={input.field}
                                className={"form-control" + (errors[input.field] && touched[input.field] ? " is-invalid" : "")}
                                >
                                  <option value="">{input.placeholder}</option>
                                  {input.optionsSelect.map((item,index)=>(
                                    <option value={item.value} key={index}>{item.label}</option>
                                  ))}
                                </Field>
                              }
                              <ErrorMessage name={input.field} component="div" className="invalid-feedback"/>
                            </FormGroup>
                          </Col>
                          </>
                        );
                      })}
                      {query.isTermsToAccept && (
                        <Col sm={12}>
      
                          <div className="d-flex flex-column no-block mb-4">
                            <Termos 
                              termosText={termosText}
                              
                              />
                            <div className="invalid-feedback d-block">{errors.isTermsToAccept}</div>
                            <div className="custom-checkbox custom-control">
                              <Field type="checkbox" name="isTermsToAccept" id="isTermsToAccept" className="custom-control-input" />
                              <Label className="custom-control-label" htmlFor="isTermsToAccept">
                                Aceite dos termos é necessário para realização desta consulta. <strong>Leia com bastante atenção!</strong>
                              </Label>
                            </div>
                            
                          </div>

                        </Col>
                      )}
                  </Row>
                  <div className="d-flex justify-content-end">
                    <Button
                      type="button"
                      color="primary"
                      onClick={submitForm}
                    >
                      {isSubmitting ? (
                        <>
                          <Spinner color="light" size="sm" /> Processando a
                          consulta...
                        </>
                      ) : (
                        <>
                          <i className=" fas fa-search"></i> Enviar
                        </>
                      )}
                    </Button>
                  </div>
                  {message && (
                    <div
                      className={`alert mt-3 ${
                        message.error ? "alert-danger" : "alert-success"
                      }`}
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: message.text }}
                      ></span>
                      <div
                        onClick={() => setMessage(null)}
                        style={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          marginRight: 10,
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                      >
                        x
                      </div>
                    </div>
                  )}
                </>
              )}
            </Formik>
          </form>
        )}
      </CardBody>
    </Card>
  );
};

export default Consultas;
